import React from 'react'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import { ModalLink } from '@gluedigital/modal'
import { useScrollSelector } from '@gluedigital/scrollastic'

import './CtaModal'
import './Cta.sass'

export const Cta = (props) => {

  const activeClass = useScrollSelector('.section', { boundary: '50px', fromBottom: true })

  return (
    <div id="cta" className={activeClass}>
      <div className="container">
        <ModalLink tagName="div" modal="cta-modal">
          <h3>
            <FormattedMessage id="cta.title" />
          </h3>
          <p>
            <MarkdownMessage id="cta.text" />
          </p>
        </ModalLink>
      </div>
    </div>
  )
}

export default Cta
